import type { ReactNode } from "react";

export type NavIconName =
  | "dashboard"
  | "projects"
  | "agents"
  | "global-data"
  | "my-actions"
  | "plus"
  | "amazon-needed"
  | "amazon-portfolio"
  | "amazon-site"
  | "amazon-process"
  | "amazon-eusdr";

const PATHS: Record<NavIconName, ReactNode> = {
  dashboard: (
    <>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </>
  ),
  projects: (
    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
  ),
  agents: (
    <>
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.3h6c0-1 .4-1.8 1-2.3A7 7 0 0 0 12 2z" />
    </>
  ),
  "global-data": (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18z" />
    </>
  ),
  // A checklist: ticks beside lines.
  "my-actions": (
    <>
      <path d="m3 7 2 2 4-4" />
      <path d="m3 17 2 2 4-4" />
      <path d="M13 6h8" />
      <path d="M13 12h8" />
      <path d="M13 18h8" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  // The Amazon overview's pages: a ticked list, a grid of buildings, one building, two
  // linked steps, and a question in a speech bubble.
  "amazon-needed": (
    <path d="M9 6h11M9 12h11M9 18h11M3.5 6l1.2 1.2L7 5M3.5 12l1.2 1.2L7 11M3.5 18l1.2 1.2L7 17" />
  ),
  "amazon-portfolio": <path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z" />,
  "amazon-site": (
    <path d="M4 21V6l8-3v18M12 9h8v12M7 9h2M7 13h2M7 17h2M15 13h2M15 17h2M2 21h20" />
  ),
  "amazon-process": <path d="M4 5h6v4H4zM14 15h6v4h-6zM7 9v3h10v3" />,
  "amazon-eusdr": (
    <path d="M4 5h16v11H9l-5 4zM10 8.5a2 2 0 1 1 2.6 1.9c-.4.2-.6.5-.6.9v.4M12 13.6v.1" />
  ),
};

export const NavIcon = ({ name }: { name: NavIconName }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    {PATHS[name]}
  </svg>
);
